import React, { Component, } from 'react'
import PropTypes from 'prop-types'

import dataMap from 'lib/dataMap'
import PlaceLookup from 'components/GoogleMaps/PlaceLookup'
import Button from 'components/_atoms/Button'

import './styles.css'

function label(title) {
  return (
    <div className="label-container">
      <div className="label">
        {title}
      </div>
    </div>
  )
}

class AddTrip extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
    nameAlreadyInUse: PropTypes.bool.isRequired,
    canCreate: PropTypes.bool.isRequired,
    startLocation: PropTypes.shape({
      name: PropTypes.string,
      lat: PropTypes.number,
      lng: PropTypes.number,
    }).isRequired,
    updateTripData: PropTypes.func.isRequired,
    createTrip: PropTypes.func.isRequired,
  }

  handleChange = (event) => {
    this.props.updateTripData({
      property: event.target.name,
      value: event.target.value,
    })
  }

  placeFound = ({ place, }) => {
    this.props.updateTripData({
      property: 'startLocation',
      value: dataMap.googlePlaceToLocation(place),
    })
  }

  changeStartLocation = () => {
    this.props.updateTripData({
      property: 'startLocation',
      value: {},
    })
  }

  render() {
    const {
      name,
      startDate,
      nameAlreadyInUse,
      canCreate,
      startLocation,
      createTrip,
    } = this.props

    return (
      <div className="add-trip-container">
        <div className="row">
          {label('Trip Name')}
          <div className="input-container">
            <input
              type="text"
              name="name"
              value={name}
              onChange={this.handleChange}
            />
            {nameAlreadyInUse &&
              <div className="input-warning">Trip name already in use</div>}
          </div>
        </div>
        <div className="row">
          {label('Start Date')}
          <div className="input-container">
            <input
              type="date"
              name="startDate"
              value={startDate}
              onChange={this.handleChange}
            />
          </div>
        </div>
        <div className={`row ${startLocation.name && 'has-place'}`}>
          {label('Start Location')}
          <div className="input-container lookup-container">
            {!startLocation.name &&
              <PlaceLookup placeFound={this.placeFound} placeHolderText="" />}
            {startLocation.name &&
              <div className="location-name">
                {startLocation.name}
                <Button
                  onClick={this.changeStartLocation}
                  small
                  className="change-location"
                >
                  Change
                </Button>
              </div>}
          </div>
        </div>
        <div className="row create-trip">
          {canCreate &&
            <Button onClick={createTrip} inverse>
              Create Trip
            </Button>}
        </div>
      </div>
    )
  }
}

export default AddTrip



// WEBPACK FOOTER //
// ./src/components/AddTrip/index.js